import React from "react";
import ParentTeacherPortal from "../ParentTeacher/ParentTeacherPortal";
export default function TeacherPortal() { return <ParentTeacherPortal forcedAudience="teacher" />; }
